import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { DashboardComponent } from '../dashboard/dashboard.component';
import { MenuService } from '../../../../services/menu.service';
import { DataIoService } from '../../../../services/data-io.service';
import { TranslationService } from '../../../../services/translation.service';
import { ConfigService } from '../../../../services/config.service';
import { MenuNode } from '../../../../classes';

@Component({
  selector: 'screen-quickaction',
  templateUrl: './quickaction.component.html',
  styleUrls: ['./quickaction.component.scss']
})
export class QuickactionComponent  implements OnInit, OnDestroy{
	@Input('debug') debug:boolean;
	dashIcon:string;
	enabled_buttons : Array<string>;
  beforeCancel:string;
  afterCancel:string;
  eventSubscription:any;
  texts:Array<string>;

  constructor(
    private menuService: MenuService, 
    private ioService: DataIoService, 
    private config: ConfigService,
    private translator: TranslationService
    ) {
    this.texts = new Array<string>();
  }

  getText(id:number){
    if(id >= 0 && id < this.texts.length){
      return this.translator.tr(this.texts[id]);
    }else{
      return "";
    }

  }
  eventHandler(event){
    console.log("Handling event "+event + " in quickaction.component");
    if(event == "back"){
      this.ioService.deviceInfo().setValue(this.mode,'off');
      this.menuService.goto(this.menuService.findItem('dashboard'));
    }
    if(event == "menu"){
      console.log("Going to mainmenu.");
      this.menuService.goto(this.menuService.findItem('mainmenu'));
    }
  }
  mode :string;
  ngOnInit() {
    this.eventSubscription = this.ioService.inputs.events$.subscribe(
      (event)=>{
        this.eventHandler(event);
      }
    );
    this.menuService.resetMenuPositions();
    if(this.ioService.deviceInfo().isInBlockingMode()){
      let states = this.ioService.deviceInfo().getBlockingStates();

      if(states.length > 0){
        this.mode = states[0];
        switch(this.mode){

          case 'cylinder_boost':{
            this.texts = [ 'DELIGHT_MAIN_MENU_ENTRY_HOTWATER_BOOST', 'HOME_CYLINDER_BOOST_SUBLINE_2','HOME_CYLINDER_BOOST_SUBLINE_3' ];
            this.beforeCancel='';
            this.dashIcon="iconDomesticWater";
            this.afterCancel="Abbrechen";
            break;
          }
          case 'ventilation_boost':{
            this.texts = [ 'HOME_VENTILATION_BOOST_SUBLINE_1','HOME_VENTILATION_BOOST_SUBLINE_2','HOME_VENTILATION_BOOST_SUBLINE_3'];
            this.beforeCancel='';
            this.dashIcon="iconVentilationBoost";
            this.afterCancel="Abbrechen";
            break; 
          }
          case 'system_off':{
            this.texts = [ 'DELIGHT_TOAST_SYSTEM_OFF', 'HOME_SYSTEMOFF_SUBLINE_2','HOME_SYSTEMOFF_SUBLINE_3' ];
            this.beforeCancel='';
            this.dashIcon="iconClose";
            this.afterCancel="Abbrechen";
          }
        }
      }
    }
  }

  ngOnDestroy(){
    if(this.eventSubscription){
      this.eventSubscription.unsubscribe();
    }      
  }

}
